import { createApp } from 'vue'
import { createRouter,createWebHistory } from 'vue-router'
import App from './App.vue'

import Home from './views/Home.vue'
import About from './views/About.vue'
import Shop from './views/Shop.vue'
import News from './views/News.vue'
import Goods from './views/Goods.vue'

const routes = [
    { path: "/", component: Home },
    { path: "/index.html", redirect: "/home" },
    { path: "/about.html", redirect: "/about" },
    {
        path: "/home",
        name: "home",
        component: Home
    },
    {
        path: "/about",
        name: "about",
        component: About
    },
    {
        path: "/shop",
        name: "shop",
        component: Shop
    },
    {
        path: "/news",
        name: "news",
        component: News
    },
    {
        path: "/goods",
        name: "goods",
        component: Goods
    }
]

const router = createRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    history: createWebHistory(),
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        }
    },
    routes, // short for `routes: routes`
})

createApp(App).use(router).mount('#app')
